	export enum DocumentTemplateEmailSourceEnum {
		System = 1,
		User = 2,
		Other = 3
	}
